import React from "react"
import { MessageBlock, StructuredMessage } from "./types"
import { HeadingRenderer } from "./HeadingRenderer"
import { ParagraphRenderer } from "./ParagraphRenderer"
import { ListRenderer } from "./ListRenderer"
import { TableRenderer } from "./TableRenderer"
import { ImageRenderer } from "./ImageRenderer"

export * from "./types"

// Main component that renders the entire structured message
export const StructuredMessageRenderer = ({
  message,
  messageId,
  linkOverride,
}: {
  message: StructuredMessage
  messageId: string
  linkOverride?: React.ComponentType<{
    href: string
    children: React.ReactNode
  }>
}) => {
  const renderBlock = (
    block: MessageBlock,
    index: number,
    messageId: string,
  ) => {
    switch (block.type) {
      case "heading":
        return (
          <HeadingRenderer
            key={index}
            block={block}
            messageId={messageId}
            linkOverride={linkOverride}
          />
        )
      case "paragraph":
        return (
          <ParagraphRenderer
            key={index}
            block={block}
            messageId={messageId}
            linkOverride={linkOverride}
          />
        )
      case "list":
        return (
          <ListRenderer
            key={index}
            block={block}
            messageId={messageId}
            linkOverride={linkOverride}
          />
        )
      case "table":
        return <TableRenderer key={index} block={block} messageId={messageId} />
      case "image":
        return <ImageRenderer key={index} block={block} messageId={messageId} />
      default:
        return null
    }
  }

  return (
    <div
      className="structured-message space-y-2"
      key={`structured-message-${messageId}`}
    >
      {message.blocks.map((block, index) =>
        renderBlock(block, index, messageId),
      )}
    </div>
  )
}

export default StructuredMessageRenderer
